export default __webpack_public_path__ + "static/media/sales-pos-img.496ae309.png";